import { useEffect } from 'react';

const MAX_ERRORS = 5;
const buffer = [];
let installed = false;
let originalConsoleError = null;

function formatArg(a) {
  if (a instanceof Error) {
    const stackHead = a.stack ? '\n' + a.stack.split('\n').slice(0, 3).join('\n') : '';
    return a.message + stackHead;
  }
  if (typeof a === 'object' && a !== null) {
    try { return JSON.stringify(a); } catch { return String(a); }
  }
  return String(a);
}

function install() {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  originalConsoleError = console.error.bind(console);
  // eslint-disable-next-line no-console
  console.error = (...args) => {
    try {
      const msg = args.map(formatArg).join(' ').slice(0, 1000);
      buffer.push({ time: new Date().toISOString(), msg });
      if (buffer.length > MAX_ERRORS) buffer.shift();
    } catch { /* never let capture break logging */ }
    originalConsoleError(...args);
  };

  // Also capture unhandled errors and promise rejections.
  window.addEventListener('error', (e) => {
    try {
      buffer.push({
        time: new Date().toISOString(),
        msg: `[window.onerror] ${e.message || 'unknown'} @ ${e.filename || '?'}:${e.lineno || '?'}`,
      });
      if (buffer.length > MAX_ERRORS) buffer.shift();
    } catch { /* ignore */ }
  });

  window.addEventListener('unhandledrejection', (e) => {
    try {
      const reason = e.reason;
      const msg = reason instanceof Error ? reason.message : String(reason);
      buffer.push({
        time: new Date().toISOString(),
        msg: `[unhandledrejection] ${msg.slice(0, 500)}`,
      });
      if (buffer.length > MAX_ERRORS) buffer.shift();
    } catch { /* ignore */ }
  });
}

export function getConsoleErrorBuffer() {
  return [...buffer];
}

export default function useConsoleErrorBuffer() {
  useEffect(() => { install(); }, []);
}
